import * as React from "react";
import type { SVGProps } from "react";
const SvgLotus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.705 10.036A6.92 6.92 0 0 1 9.39 5.71l2-1.51a1 1 0 0 1 1.2 0l2 1.51a6.92 6.92 0 0 1 2.685 4.328Q17.635 10 18 10h3a1 1 0 0 1 1 1v2a7 7 0 0 1-7 7H9a7 7 0 0 1-7-7v-2a1 1 0 0 1 1-1h3q.355 0 .705.036m8.606.501A5 5 0 0 0 13.37 7.31L12 6.25l-1.41 1.06a5 5 0 0 0-1.938 3.212A7 7 0 0 1 12 13.394a7 7 0 0 1 3.31-2.857M9 18h2v-1a5 5 0 0 0-5-5H4v1a5 5 0 0 0 5 5m6 0h-2v-1a5 5 0 0 1 5-5h2v1a5 5 0 0 1-5 5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLotus;
